module.exports = __webpack_public_path__ + "static/media/branding.48478912.svg";